    const isMobile = false
    export default {
        isMobile
    }